import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  RequestHook_instanceaw1sbzrckls9 as RequestHook_instance,
  TransformRequestBodyHook_instance3isql5xg2cuq7 as TransformRequestBodyHook_instance,
  TransformResponseBodyHook_instance14phngq6mxh8h as TransformResponseBodyHook_instance,
} from './KtorCallContexts.mjs';
import { HookHandler356pvj77mag23 as HookHandler } from './ClientHook.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
var ClientPluginBuilderClass;
function ClientPluginBuilder() {
  if (ClientPluginBuilderClass === VOID) {
    class $ {
      constructor(key, client, pluginConfig) {
        this.s5m_1 = key;
        this.t5m_1 = client;
        this.u5m_1 = pluginConfig;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.v5m_1 = ArrayList().p2();
        var tmp_0 = this;
        tmp_0.w5m_1 = ClientPluginBuilder$onClose$lambda;
      }
      v5q(block) {
        this.x5m(RequestHook_instance, block);
      }
      o5s(block) {
        this.x5m(TransformRequestBodyHook_instance, block);
      }
      m5p(block) {
        this.x5m(TransformResponseBodyHook_instance, block);
      }
      x5m(hook, handler) {
        this.v5m_1.j2(new (HookHandler())(hook, handler));
      }
    }
    initMetadataForClass($, 'ClientPluginBuilder');
    ClientPluginBuilderClass = $;
  }
  return ClientPluginBuilderClass;
}
//region block: exports
export {
  ClientPluginBuilder as ClientPluginBuilder3nx9qxmpfnzts,
};
//endregion

//# sourceMappingURL=ClientPluginBuilder.mjs.map
